import './Icon.css';
export default {
    "root": "Icon_root__1kdkz",
    "icon-xxsmall": "Icon_icon-xxsmall__1kdkz",
    "icon-xsmall": "Icon_icon-xsmall__1kdkz",
    "icon-small": "Icon_icon-small__1kdkz",
    "icon-medium": "Icon_icon-medium__1kdkz",
    "icon-large": "Icon_icon-large__1kdkz",
    "icon-xlarge": "Icon_icon-xlarge__1kdkz",
    "icon-custom": "Icon_icon-custom__1kdkz"
};
